import { getBrowserLocaleCode } from "@/utils/date-util";
import i18next from "@/utils/i18n/client";

export const SUPPORTED_LANGUAGES = ["ko", "en", "ja"] as const;
export type SupportedLanguageCode = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: SupportedLanguageCode = "ko";

const isSupportedLanguage = (code: string | null | undefined): code is SupportedLanguageCode =>
  !!code && SUPPORTED_LANGUAGES.includes(code as SupportedLanguageCode);

/**
 * 사용자가 선택한 언어 코드를 반환합니다.
 * - 1순위: i18next에 적용된 현재 언어 (언어 선택기에서 변경한 값)
 * - 2순위: localStorage에 저장된 언어 (i18next 초기화 이전 접근 대비)
 * - 3순위: 브라우저 언어
 * - 지원하지 않는 언어는 한국어 기본값 사용
 */
export function getSelectedLanguageCode(): SupportedLanguageCode {
  const candidates = [
    i18next.language,
    typeof window !== "undefined" ? localStorage.getItem("language") : null,
    getBrowserLocaleCode(),
  ];

  for (const candidate of candidates) {
    const code = candidate?.split("-")[0];
    if (isSupportedLanguage(code)) {
      return code;
    }
  }

  return DEFAULT_LANGUAGE;
}
